import { render, staticRenderFns } from "./TelegramIntegration.vue?vue&type=template&id=7fa02efe&scoped=true&"
import script from "./TelegramIntegration.vue?vue&type=script&lang=js&"
export * from "./TelegramIntegration.vue?vue&type=script&lang=js&"
import style0 from "./TelegramIntegration.vue?vue&type=style&index=0&id=7fa02efe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa02efe",
  null
  
)

export default component.exports